import { Component,OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import * as Aos from 'aos';
@Component({
  selector: 'app-inBound',
  templateUrl: './inBound.component.html',
  styleUrls: ['./inBound.component.scss']
})
export class InBoundComponent implements OnInit {
  
  constructor(
    private titleService: Title,
  )
  {    }

  ngOnInit(){
    this.titleService.setTitle('In-Bound');
 
    setTimeout(() => {
      Aos.init();
    }, 500);       
      Aos.refresh();
  }
}
